<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <OffsetByPlate />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import OffsetByPlate from '@/components/settings/parameters/offsetbyplate/OffsetByPlate'

export default {
  name: 'OffsetByPlateView',
  components: {
    PageTitle,
    PageRowWrapper,
    OffsetByPlate
  }
}
</script>